import React from 'react'
import { Switch, Route, useLocation, Link } from 'react-router-dom'
import { useGlobalState } from '@/state'

import Breadcrumbs from '@/Layout/Breadcrumbs'
import PageTitle from '@/Layout/PageTitle'

import { NewCreditForm, CreditEdit } from '@/pages/Credits/CreditEdit'
import CreditIndex from '@/pages/Credits/CreditIndex'
import CreditManage from '@/pages/Credits/CreditManage'
import CreditSearch from '@/pages/Credits/CreditSearch'
import CreditShow from '@/pages/Credits/CreditShow'

function breadCrumbs() {
  const location = useLocation()
  const activePath = location.pathname
  const [credit] = useGlobalState('credit')
  const crumbs = [
    { to: '/credits', name: 'Production Credits' }
  ]
  if (activePath === '/credits/search') {
    crumbs.push({ to: '/credits/search', name: 'Search Credits' })
  }
  if (activePath === '/credits/new') {
    crumbs.push({ to: '/credits/new', name: 'New Credit' })
  }
  if (activePath.includes('/edit')) {
    crumbs.push({ to: activePath, name: 'Edit Credit' })
  }
  if (activePath.includes('/credits/') && activePath !== '/credits/new') {
    crumbs.push({ to: activePath, name: credit?.name })
  }
  return crumbs
}

function pageTitle() {
  const location = useLocation()
  const activePath = location.pathname
  const [credit] = useGlobalState('credit')

  const titleInfo = {
    title: 'Production Credits',
    buttons: [
      <Link key="search-credits" to="/credits/search" className="inline-flex justify-center px-4 py-2 shadow-sm text-sm font-medium rounded-md text-white bg-cccblue hover:bg-cccblue-alt hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cccblue mb-2">
        Search All Credits
      </Link>
    ]
  }
  if (activePath === '/credits/search') {
    titleInfo.title = 'Search Credits'
    titleInfo.buttons = []
  }
  if (activePath === '/credits/new') { titleInfo.title = 'New Credit' }
  if (activePath.includes('/credits/') && activePath !== '/credits/new' && activePath !== '/credits/search' && credit?.name) {
     titleInfo.title = credit?.name
  }
  return titleInfo
}

export default function CreditsContainer(props) {
  const crumbs = breadCrumbs()
  const titleInfo = pageTitle()

  return <>
    <Breadcrumbs>
      { crumbs.map((crumb, index) => (
        <Link key={`${index}${crumb.name}`} to={crumb.to} className="text-xs sm:text-sm text-gray-500 hover:text-gray-700 dark:text-gray-100">
          {crumb.name}
        </Link>
      ))}
    </Breadcrumbs>
    <PageTitle pagetitle={titleInfo.title}>
      {titleInfo.buttons}
    </PageTitle>
    <Switch>
      <Route {...props} exact path={['/credits/search']}>
        <CreditSearch />
      </Route>
      <Route {...props} exact path={['/credits/new']}>
        <NewCreditForm />
      </Route>
      <Route {...props} exact path={['/credits/:id/manage']}>
        <CreditManage />
      </Route>
      <Route {...props} exact path={['/credits/:id/edit']}>
        <CreditEdit />
      </Route>
      <Route {...props} exact path={['/credits/:slug']}>
        <CreditShow />
      </Route>
      <Route {...props} exact path={['/credits']}>
        <CreditIndex />
      </Route>
    </Switch>
  </>
}
